import { useSelector } from 'react-redux';
import { ErrorMessage, Field } from 'formik';
import { isEmpty, sum } from 'lodash';
import { price } from 'utils/helpers';
import { PRICING_SECTION } from 'redux/actions/availability';
import { getChildResources } from 'redux/selectors/booking_form';

export const renderExtraPicks = (
  selectedResourceId,
  selectedDate,
  passengers
) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const childResources = useSelector((state) =>
    getChildResources(state, { selectedResourceId, selectedDate })
  );
  const passengerCount = sum(Object.values(passengers));

  if (isEmpty(childResources) || passengerCount === 0) {
    return null;
  }

  const priceString = (extraPick) => {
    const paxPricing =
      extraPick?.pricing?.[PRICING_SECTION.passenger][selectedDate]
        ?.pricing_details?.price_per_pax_type;

    if (isEmpty(paxPricing)) {
      return null;
    }

    const maxPrice = parseInt(Math.max(...Object.values(paxPricing))) || 0;

    return `${price(maxPrice)} per person`;
  };

  return (
    <div role="group" aria-labelledby="checkbox-group">
      <div className="px-4 py-3 border-top border-divider bg-light">
        <h3 className="body-text strong">Optional extras</h3>
      </div>
      <div className="p-4 space-y-3">
        {childResources.map((extraPick) => (
          <div
            className="custom-control form-checkbox form-check"
            key={`extrapick-checkbox-${extraPick.id}`}
          >
            <Field
              type="checkbox"
              name="extraPicks"
              id={`extraPick-${extraPick.id}`}
              className="custom-control-input form-check-input"
              value={extraPick.id.toString()}
            />
            <label
              htmlFor={`extraPick-${extraPick.id}`}
              className="custom-control-label"
            >
              {extraPick.name}
            </label>
            <div className="text-xx-small mt-1">{priceString(extraPick)}</div>
          </div>
        ))}

        <ErrorMessage
          name="daextraPickste"
          component="div"
          className="text-danger text-x-small"
          id="error-extraPicks"
        />
      </div>
    </div>
  );
};
